import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import { img10 } from "../_components/Imagepath";
import axios from "axios";

import DatePicker from "react-datepicker";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
const AccountSettings = () => {

  const [selectedGender, setSelectedGender] = useState(null);

  // const defaultImage = img10; // default image

  // const [profileImage, setProfileImage] = useState(defaultImage);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [dob, setDob] = useState(null);
  const [address, setAddress] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' }
  ];



  useEffect(() => {
    const savedImage = localStorage.getItem("profileImage");
    if (savedImage) {
      // setProfileImage(savedImage);
    }
  
    const savedUserData = localStorage.getItem("userData");
    if (savedUserData) {
      const data = JSON.parse(savedUserData);
      setFirstName(data.firstName || '');
      setLastName(data.lastName || '');
      setEmail(data.email || '');
      setMobileNumber(data.mobileNumber || '');
      setSelectedGender(data.gender ? { value: data.gender, label: data.gender } : null);
      setDob(data.dob ? new Date(data.dob) : null);
      setAddress(data.address || '');
      setCountry(data.country || '');
      setState(data.state || '');
      setCity(data.city || '');
      setPostalCode(data.postalCode || '');
    }
  }, []);
  

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       const base64Image = reader.result;
  //       setProfileImage(base64Image);
  //       localStorage.setItem("profileImage", base64Image); // Save to localStorage
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const handleDeleteImage = () => {
  //   setProfileImage(img10); // Reset to default image
  //   localStorage.removeItem('profileImage'); // Remove from localStorage
  // };

  const userData = {
    firstName,
    lastName,
    email,
    mobileNumber,
    gender: selectedGender ? selectedGender.value : '',
    dob,
    address,
    country,
    state,
    city,
    postalCode
  };
  localStorage.setItem('userData', JSON.stringify(userData));

  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          {/* /Page Header */}
          <div className="row">
            <div className="col-xl-3 col-md-4">
              {/* <SettingsSidebar /> */}
            </div>
            <div className="row">
  <div className="col-12">

    <div className="card w-100">
      <div className="card-body">

        {/* HEADER */}
        <div className="content-page-header mb-4">
          <h5 className="setting-menu">Account Settings</h5>
        </div>

        <div className="row">

          {/* PROFILE IMAGE */}
          {/* <div className="col-12 mb-4">
            <div className="profile-picture d-flex align-items-center flex-wrap">
              <div className="upload-profile me-3">
                <div className="profile-img">
                  <img
                    className="avatar"
                    src={profileImage}
                    alt="profile-img"
                  />
                </div>
              </div>

              <div className="img-upload">
                <label className="btn btn-primary me-2">
                  Upload new picture
                  <input
                    type="file"
                    hidden
                    onChange={handleImageChange}
                    accept="image/*"
                  />
                </label>

                <button
                  type="button"
                  className="btn btn-remove"
                  onClick={handleDeleteImage}
                >
                  Delete
                </button>

                <p className="mt-1 text-muted">
                  Logo should be minimum 152×152. Supported formats: JPG, PNG, SVG
                </p>
              </div>
            </div>
          </div> */}

          {/* GENERAL INFORMATION */}
          <div className="col-12">
            <div className="form-title">
              <h5>General Information</h5>
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>First Name</label>
              <input
                className="form-control"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>Last Name</label>
              <input
                className="form-control"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>Mobile Number</label>
              <input
                className="form-control"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>Gender</label>
              <Select
                value={selectedGender}
                onChange={setSelectedGender}
                options={genderOptions}
                placeholder="Select Gender"
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3 position-relative">
              <label>Date of Birth</label>
              <DatePicker
                className="form-control"
                selected={dob}
                onChange={(date) => setDob(date)}
                dateFormat="dd/MM/yyyy"
              />
              <div className="datepicker-icon">
                <FeatherIcon icon="calendar" />
              </div>
            </div>
          </div>

          {/* ADDRESS INFORMATION */}
          <div className="col-12">
            <div className="form-title">
              <h5>Address Information</h5>
            </div>
          </div>

          <div className="col-12">
            <div className="input-block mb-3">
              <label>Address</label>
              <input
                className="form-control"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>Country</label>
              <input
                className="form-control"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>State</label>
              <input
                className="form-control"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>City</label>
              <input
                className="form-control"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-6 col-12">
            <div className="input-block mb-3">
              <label>Postal Code</label>
              <input
                className="form-control"
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </div>
          </div>

          {/* BUTTONS */}
          <div className="col-12">
            <div className="btn-path text-end">
              <Link to="/profile" className="btn btn-cancel bg-primary-light me-3">
                Cancel
              </Link>
           <button
  className="btn btn-primary"
  onClick={async () => {
    const company = JSON.parse(localStorage.getItem("company"));
    if (!company) return;

    const res = await axios.put(
      `http://localhost:5000/api/companies/profile/${company.id}`,
      {
        company_name: `${firstName} ${lastName}`,
        contact_number: mobileNumber,
        address,
        city,
        state,
        country,
        photo_url: company.photo_url, // ✅ SAFE
      }
    );

    if (res.data.success) {
      localStorage.setItem(
        "company",
        JSON.stringify(res.data.company)
      );
      window.dispatchEvent(new Event("storage"));
      alert("Profile Updated!");
      window.location.href = "/profile";
    }
  }}
>
  Save Changes
</button>



            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

          </div>
        </div>
      </div>
    </>
  );
};
export default AccountSettings;
